import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteDepartmentsAction } from 'src/redux/actions/dataActions';

const DeleteDepartmentDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteDepartment]) {
        return state.dialog[DIALOGS.deleteDepartment];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteDepartment }));
  };

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteDepartment }));
    dispatch(deleteDepartmentsAction(payload.id));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-department"
      open={opened}>
      <DialogTitle id="deleting-department">{t(lang, 'menus.deleting_department')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_department_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDepartmentDialog;
